import { render, staticRenderFns } from "./IBackupStatusDropdown.vue?vue&type=template&id=4a4e4d4b&"
import script from "./IBackupStatusDropdown.vue?vue&type=script&lang=js&"
export * from "./IBackupStatusDropdown.vue?vue&type=script&lang=js&"
import style0 from "./IBackupStatusDropdown.vue?vue&type=style&index=0&id=4a4e4d4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports